export function getQueryArg(key: string, standard?: any, url: string = document.location.href): string {
    const result = url.match(new RegExp('[\?\&]' + key + '=([^\&]+)'))
    return (result == null || result.length < 1) ? standard : decodeURIComponent(result[1].replace(/\+/g, ' '));
}

export function domCreate<K extends keyof HTMLElementTagNameMap>(tagName: K, className?: string, container?: HTMLElement): HTMLElementTagNameMap[K] {
    const el = window.document.createElement(tagName);
    if (className !== undefined) el.className = className;
    if (container) container.appendChild(el);
    return el;
}
